import React from 'react';
import { useSelector } from 'react-redux';
import { MapContainer, AddressContentWrapper, DisabledMap } from './MapLayout.styles';
import SearchLocationInput from '../SearchLocationInput';
import { selectDealersList } from '../../reducers/dealersListReducer';
import Map from '../Map/indexCopy';

const MapLayout: React.FC = () => {
  const { centerLocation, isEdit } = useSelector(selectDealersList);

  return (
    <>
      <MapContainer>
        {centerLocation ? (
          <Map />
        ) : (
          <>
            <DisabledMap />
          </>
        )}
        <AddressContentWrapper width={isEdit ? 'unset' : '100%'} height={isEdit ? 'unset' : '100%'}>
          <SearchLocationInput />
        </AddressContentWrapper>
      </MapContainer>
    </>
  );
};

export default MapLayout;
